import React, { Fragment } from 'react'
import { useTranslation } from 'react-i18next'
import { useQuery, useMutation } from 'components/graphql'

import styled from 'styled-components'
import { ExpandableBlocks, ContentBlock } from 'components/ContentBlock'
import { Form, Text, Number as NumberInput, Select, Checkbox } from 'components/forms'
import Button from 'components/Button'
import { Row, Col } from 'react-flexbox-grid'
import Divider from 'components/Divider'
import { Modal } from 'components/Modal'
import { notEmpty } from 'helpers/validators'
import CashRegisterList from 'components/CashRegisterTree'
import ContenHeader from 'components/ContenHeader'
import updateOrderType from './gql/updateOrderType'
import updateGlobalCR from '../../gql/updateGlobalCR'
import { listCreditClients } from 'sections/creditClient/gql'
import getListStorageRelation from './gql/getListStorageRelation'
import getAppConfig from '../../gql/getAppConfig'
import get from 'lodash/get'

const StyledOrders = styled.div`
	& .generalSettingsRow {
		display: flex;
		margin-bottom: 20px;
		& > div:first-child {
			margin-right: 26px;
		}
	}
	& .firstSettingsRow .secondSettingsCol {
		margin-top: 26.44px;
	}
`

const Orders = ({ data, formData, mutations: { updateItem, createItem }, newRecord, itemViewProps }) => {
	const [t, i18n] = useTranslation()
	const { data: globalAppConfig } = useQuery(getAppConfig)
	const [updateGlobalReturnType] = useMutation(updateGlobalCR.order)
	const [updateCashRegistersOrder] = useMutation(updateOrderType)
	const returnType = get(globalAppConfig, 'getAppConfig.cashRegisterGlobal.returnType')

	const firstDateOptions = [
		{ value: 0, label: '+0' },
		{ value: 1, label: '+1' },
		{ value: 2, label: '+2' },
		{ value: 3, label: '+3' },
		{ value: 4, label: '+4' },
		{ value: 5, label: '+5' },
		{ value: 6, label: '+6' },
		{ value: 98, label: t('options_section.strings.inventory_days') },
		{ value: 99, label: t('options_section.strings.current_days') }
	]
	const reportCountOptions = [
		{ value: 1, label: '1' },
		{ value: 2, label: '2' },
		{ value: 3, label: '3' },
		{ value: 99, label: 'Any' }
	]
	const customerOptions = [
		{ value: -1, label: '<std 1>' },
		{ value: -2, label: '<std 2>' },
		{ value: -3, label: '<std 3>' },
		{ value: -4, label: '<std 4>' },
		{ value: -5, label: '<std 5>' },
		{ value: -6, label: '<std 6>' },
		{ value: -7, label: '<std 7>' },
		{ value: -8, label: '<std 8>' },
		{ value: -9, label: '<std 9>' },
		{ value: -10, label: '<std 10>' }
	]

	const orderTypesOptions = [
		{ value: 'Return', label: t('options_section.strings.return') },
		{ value: 'Transfer', label: t('options_section.strings.shift') },
		{ value: 'Inventory', label: t('options_section.strings.inventory') },
		{ value: 'DeliveryCorrection', label: t('options_section.strings.delivery_correction') },
		{ value: 'Order', label: t('options_section.strings.order') },
		{ value: 'CustomerOrder', label: t('options_section.strings.customer_order') },
		{ value: 'PreOrderCreditCustomer', label: t('options_section.strings.pre_order_credit_customer') }
	]


	const handleSubmit = vals => {
		let convertEnumTypeToInt, standardValueByOrderType
		switch(vals.orderTypeStandartised) {
			case 'Return':
				convertEnumTypeToInt = 20
				standardValueByOrderType = {
					isActive: true,
					firstDate: 99,
					dateSpan: null,
					rawCreditClientId: -1,
					storageRelationId: 2,
					reportCount: 1,
					reportKind: 0,
					statisticDate1: null,
					statisticDate2: null,
					showStatistic: false,
					countOptions: 1,
					printOptions: true,
					reportMode: false,
					lookAndFeel: true,
					showAllButton: false
				}
				break
			case 'Transfer':
				convertEnumTypeToInt = 7
				standardValueByOrderType = {
					isActive: true,
					firstDate: 99,
					dateSpan: null,
					reportCount: 99,
					rawCreditClientId: -1,
					storageRelationId: 0,
					reportKind: 0,
					statisticDate1: null,
					statisticDate2: null,
					showStatistic: false,
					countOptions: 0,
					printOptions: true,
					reportMode: false,
					lookAndFeel: true,
					showColumnPrice: true,
					showColumnTotalPrice: true,
					updateReportAfterSale: false,
					showAllButton: false
				}
				break
			case 'DeliveryCorrection':
				convertEnumTypeToInt = 6
				standardValueByOrderType = {
					isActive: true,
					firstDate: 99,
					dateSpan: null,
					reportCount: 99,
					rawCreditClientId: -1,
					storageRelationId: 1,
					reportKind: 0,
					statisticDate1: null,
					statisticDate2: null,
					showStatistic: false,
					countOptions: 1,
					printOptions: true,
					reportMode: false,
					lookAndFeel: true,
					showColumnPrice: false,
					showColumnTotalPrice: false,
					updateReportAfterSale: false,
					showMinusButton: true,
					showAllButton: false
				}
				break
			case 'Order':
				convertEnumTypeToInt = 2
				standardValueByOrderType = {
					isActive: true,
					firstDate: 1,
					dateSpan: 7,
					reportCount: 1,
					rawCreditClientId: -1,
					storageRelationId: 1,
					reportKind: 7,
					statisticDate1: 7,
					statisticDate2: 14,
					showStatistic: true,
					countOptions: 0,
					printOptions: true,
					reportMode: false,
					lookAndFeel: true,
					showAllButton: false
				}
				break
			case 'CustomerOrder':
				convertEnumTypeToInt = 51
				standardValueByOrderType = {
					isActive: true,
					firstDate: 1,
					dateSpan: 14,
					reportCount: 99,
					rawCreditClientId: -1,
					storageRelationId: 1,
					reportKind: 7,
					statisticDate1: null,
					statisticDate2: null,
					showStatistic: false,
					countOptions: 1,
					printOptions: true,
					reportMode: false,
					lookAndFeel: true,
					showColumnPrice: false,
					showColumnTotalPrice: false,
					showMinusButton: false,
					updateReportAfterSale: false,
					showAllButton: false
				}
				break
			case 'PreOrderCreditCustomer':
				convertEnumTypeToInt = 50
				standardValueByOrderType = {
					isActive: true,
					firstDate: 1,
					dateSpan: 31,
					reportCount: 1,
					rawCreditClientId: -1,
					storageRelationId: 1,
					reportKind: 7,
					statisticDate1: null,
					statisticDate2: null,
					showStatistic: false,
					countOptions: 0,
					printOptions: true,
					reportMode: false,
					lookAndFeel: true,
					showColumnPrice: false,
					showColumnTotalPrice: false,
					showMinusButton: false,
					updateReportAfterSale: false,
					showAllButton: false
				}
				break
			case 'Inventory':
				convertEnumTypeToInt = 100
				standardValueByOrderType = {
					isActive: true,
					firstDate: 0,
					dateSpan: 1,
					rawCreditClientId: -1,
					storageRelationId: 1,
					reportCount: 1,
					reportKind: 7,
					statisticDate1: null,
					statisticDate2: null,
					showStatistic: false,
					countOptions: 1,
					printOptions: true,
					reportMode: false,
					lookAndFeel: true,
					showColumnPrice: false,
					showColumnTotalPrice: false,
					showMinusButton: false,
					updateReportAfterSale: false,
					showAllButton: false
				}
				break
			default:
		}


		const newVals = { ...vals, ...standardValueByOrderType, type: convertEnumTypeToInt }
		if(newRecord) {
			createItem(newVals)
		} else {
			updateItem(vals)
		}
	}
	const handleUpdateGlobalReturnType = val => {
		updateGlobalReturnType({
			variables: {
				fields: {
					cashRegisterGlobal: {
						returnType: val.value
					}
				}
			}
		})
	}
	return (
		<StyledOrders>
			<ContenHeader title={t('options_section.sub_sections.order_together')} />
			<ExpandableBlocks>
				<Form
					initialValues={formData}
					onSubmit={handleSubmit}
					smartSubmit={!newRecord}
					render={({ formState: { values } }) => (
						<Fragment>
							<ContentBlock label={t('options_section.strings.general')}>
								<Row className='generalSettingsRow firstSettingsRow'>
									<Col xs={3}>
										<Select
											label={t('options_section.strings.order_type')}
											field='orderTypeStandartised'
											placeholder={t('options_section.strings.individual')}
											usePlaceholder
											{...notEmpty()}
											validateOnChange
											options={orderTypesOptions}
											isOptionDisabled={(options) => options.disabled}
										/>
									</Col>
									<Col xs={3} className='secondSettingsCol'>
										<Checkbox
											disabled={newRecord}
											field='isActive'
											inline
											label={t('options_section.strings.active')}
										/>
									</Col>
								</Row>
								<Row className='generalSettingsRow'>
									<Col xs={3}>
										<NumberInput
											{...notEmpty()}
											label={t('common.fields.code')}
											field='code'
											placeholder={t('common.placeholders.number')}
											validateOnChange
										/>
									</Col>
									<Col xs={3}>
										<Text
											label={t('common.fields.name')}
											field='name'
											{...notEmpty()}
											validateOnChange
										/>
									</Col>
								</Row>
								<Row className='generalSettingsRow'>
									<Col xs={3}>
										<Select
											field='firstDate'
											disabled={newRecord}
											options={firstDateOptions}
											label={t('options_section.strings.first_day')}
										/>
									</Col>
									<Col xs={3}>
										<NumberInput
											field='dateSpan'
											disabled={values.firstDate >= 98 || newRecord}
											label={t('options_section.strings.number_of_days')}
											shrink
										/>
									</Col>
								</Row>
								<Row className='generalSettingsRow'>
									<Col xs={3}>
										<Select
											field='reportCount'
											disabled={newRecord}
											options={reportCountOptions}
											label={t('options_section.strings.number_of_orders')}
										/>
									</Col>
								</Row>
							</ContentBlock>
							<ContentBlock label={t('options_section.fields.additive')}>
								<Row>
									<Col xs={4}>
										<Select
											field='rawCreditClientId'
											disabled={newRecord}
											remoteOptions={{
												query: listCreditClients,
												modifyOptions: item => {
													const res = item.map((elem) => ({ value: elem.id, label: elem.name }))
													return [...customerOptions, ...res]
												}
											}}
											label={t('common.strings.customer')} />
										<Select
											field='storageRelationId'
											disabled={newRecord}
											remoteOptions={{
												query: getListStorageRelation,
												variables: { language: i18n.language },
												modifyOptions: item => item.map(elem => ({ value: +elem.id, label: elem.name }))
											}}
											label={t('options_section.strings.stock_link')}
										/>
										<Checkbox disabled={newRecord} field='showAllButton' label={t('common.strings.all_products')} />
										{(data.orderTypeStandartised === 'Return' || data.orderTypeStandartised === 'Inventory') &&
											<Checkbox disabled={newRecord} field='isTemplateMode' label={t('options_section.strings.template_view')} />
										}
									</Col>
									<Col xs={2}>
										<Checkbox disabled={newRecord} field='isMon' label={t('common.dates.monday')} />
										<Checkbox disabled={newRecord} field='isTue' label={t('common.dates.tuesday')} />
										<Checkbox disabled={newRecord} field='isWed' label={t('common.dates.wednesday')} />
										<Checkbox disabled={newRecord} field='isThu' label={t('common.dates.thursday')} />
										<Checkbox disabled={newRecord} field='isFri' label={t('common.dates.friday')} />
										<Checkbox disabled={newRecord} field='isSat' label={t('common.dates.saturday')} />
										<Checkbox disabled={newRecord} field='isSun' label={t('common.dates.sunday')} />
									</Col>
									{data.orderTypeStandartised === 'Return' &&
									<Col xs={3}>
										<Select
											noForm
											defaultValue={returnType}
											onChange={handleUpdateGlobalReturnType}
											label={t('options_section.fields.filtered_by')}
											options={[
												{ value: '1', label: t('options_section.strings.default_order') },
												{ value: '2', label: t('options_section.strings.evening_return') }
											]}
										/>
									</Col>
									}
								</Row>
							</ContentBlock>
							{itemViewProps.showCashRegistersModal &&
							<Modal
								unmount={() => itemViewProps.toggleCashRegisterModal(false)}
								height={600}
								width={660}
								label={t('common.fields.cash_register')}>
								<CashRegisterList
									startConcealed
									activeNodesArr={data.cashRegisterId}
									hideNoCRBranches
									cardsInRow={1}
									onChange={(idArr) => updateCashRegistersOrder({ variables: { id: data.id, fields: { cashRegisterId: idArr } } })}
									inverted
								/>
							</Modal>}
							{newRecord &&
									<Fragment>
										<Divider />
										<div>
											<Button
												type='submit'
												status={(values.code && values.name) ? 'primary' : 'inactive'}
												text={t('common.buttons.create')}
											/>
										</div>
									</Fragment>
							}
						</Fragment>
					)}
				/>
			</ExpandableBlocks>
		</StyledOrders>
	)
}

export default Orders
